import { DesignMenuState, DesignTabs } from './DesignMenu.types'
import { useCurrentPage } from '@dtx-company/inter-app/src/redux/slices/utils/currentPage'
import React from 'react'

export function useDesignMenuState(): DesignMenuState {
  const [curTab, setTab] = React.useState(DesignTabs.COLOR)
  const page = useCurrentPage()
  return { curTab, setTab, pageTheme: page?.theme }
}
